'use strict';

import Component from 'generic.basecomponent';

export default class Sharethis extends Component {
	constructor(element) {
		super(element);
		this.init();
	}

	init() {
	    this.property = this.container.dataset.property;
        this.shareThisScript = document.createElement('script');
        this.shareThisScript.type = 'text/javascript';
        this.shareThisScript.async = true;
        this.shareThisScript.src = `//platform-api.sharethis.com/js/sharethis.js#property=${this.property}&product=inline-share-buttons`;
        document.head.appendChild(this.shareThisScript);
    }
}

Sharethis.id = 0;



// WEBPACK FOOTER //
// ./app/components/sharethis/js/generic.sharethis.js